<script setup lang="ts">
import OzIcon from '@@/library/v4/components/OzIcon.vue'
import OzLoadingSpinnerWithCheckmark from '@@/library/v4/components/OzLoadingSpinnerWithCheckmark.vue'
import { computed } from 'vue'

const SPINNER_SIZE_OFFSET = 10

const props = withDefaults(
  defineProps<{
    showIndicator: boolean
    darkMode: boolean
    size: 20 | 24
    isLoading?: boolean
  }>(),
  {
    isLoading: false,
  },
)

const iconColor = computed(() => {
  return props.darkMode ? 'black' : 'white'
})

// This is Orizuru selection color, canary and grape
const indicatorColor = computed(() => (props.darkMode ? '#FEC006' : '#9466E8'))

// Offset the spinner size by 10px so it wraps the globe icon
const spinnerSize = computed(() => props.size + SPINNER_SIZE_OFFSET)

const spinnerColor = computed(() => (props.darkMode ? 'yellow' : 'purple'))

const spinnerPosition = computed(() => `absolute top-[-5px] start-[-5px]`)

const indicatorSize = computed(() => (props.size === 20 ? 12 : 16))

const indicatorPosition = computed(() => (props.size === 20 ? 'top-[-1.5px] start-2.375' : '-top-0.75 start-2.75'))
</script>

<template>
  <div class="relative">
    <OzIcon name="globe" :size="size" :class="[darkMode ? 'text-light-text-200' : 'text-dark-text-200']" />

    <div v-if="isLoading" :class="spinnerPosition">
      <OzLoadingSpinnerWithCheckmark :size="spinnerSize" :color="spinnerColor" />
    </div>

    <!-- We don't want the indicator to show when the globe is loading -->
    <template v-if="showIndicator && !isLoading">
      <svg
        :width="indicatorSize"
        :height="indicatorSize"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        :class="['absolute', indicatorPosition]"
      >
        <path
          d="M8 0.5C12.1359 0.500001 15.5 3.86406 15.5 8C15.5 12.1359 12.1359 15.5 8 15.5C3.86406 15.5 0.500001 12.1359 0.5 8C0.5 3.86406 3.86406 0.5 8 0.5Z"
          :fill="indicatorColor"
          :stroke="iconColor"
        />
        <path
          d="M11.6924 4.78205C11.5 4.78765 11.3173 4.86793 11.183 5.00587L6.76717 9.42168L4.82121 7.47572C4.75293 7.40461 4.67116 7.34783 4.58067 7.30872C4.49017 7.26961 4.39279 7.24895 4.29421 7.24795C4.19564 7.24695 4.09785 7.26563 4.00659 7.30289C3.91532 7.34015 3.8324 7.39525 3.7627 7.46495C3.69299 7.53466 3.63789 7.61758 3.60063 7.70884C3.56337 7.80011 3.54469 7.8979 3.54569 7.99647C3.54669 8.09505 3.56736 8.19243 3.60647 8.28292C3.64557 8.37342 3.70235 8.45519 3.77346 8.52347L6.2433 10.9933C6.38226 11.1322 6.57069 11.2102 6.76717 11.2102C6.96365 11.2102 7.15209 11.1322 7.29105 10.9933L12.2307 6.05363C12.3376 5.94952 12.4106 5.81557 12.4401 5.6693C12.4696 5.52304 12.4543 5.37127 12.3961 5.23386C12.3379 5.09646 12.2396 4.97981 12.1141 4.8992C11.9885 4.81858 11.8415 4.77775 11.6924 4.78205Z"
          :fill="iconColor"
        />
      </svg>
    </template>
  </div>
</template>
